import React from 'react'
import Header from './Components/Header'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import HomeSection from './Components/HomeSection'
import Footer from './Components/Footer'
import AboutUs from './Components/AboutUs'


import PreWeddingandWedding from './Components/PreWeddingandWedding'
import ModelingAndActing from './Components/ModelingAndActing'
import CommercialAndIndustrial from './Components/CommercialAndIndustrial'
import FashionandBeauty from './Components/FashionandBeauty'
import ProductsandBrands from './Components/ProductsandBrands'
import EventsandCelebrations from './Components/EventsandCelebrations'
import CreativeandArts from './Components/CreativeandArts'
import MaternityAndBaby from './Components/MaternityAndBaby'
import LoveandFamily from './Components/LoveandFamily'
import CelebrityAndMovieMedia from './Components/CelebrityAndMovieMedia'
import ActingPhotographyPortfolio from './Components/ActingPhotographyPortfolio'
import ChildPhotographyPortfolio from './Components/ChildPhotographyPortfolio'
import WeddingPhotographyPortfolio from './Components/WeddingPhotographyPortfolio'
import ProductPhotographyPortfolio from './Components/ProductPhotographyPortfolio'
import FashionPhotographyPortfolio from './Components/FashionPhotographyPortfolio'
import InteriorPhotographyPortfolio from './Components/InteriorPhotographyPortfolio'
import CorporatePhotographyPortfolio from './Components/CorporatePhotographyPortfolio'

import Career from './Components/Career'
import ImageGallery from './Components/ImageGallery'
import VideoGallery from './Components/VideoGallery'

import ContactUs from './Components/ContactUs'


const App = () => {
  return (
    <div>

      <BrowserRouter >
      <Header />
        <Routes>
          <Route path="/" element={<HomeSection />} />
          <Route path="/about-us" element={<AboutUs />} />
          
          <Route path='/pre-wedding-and-wedding-photography' element={<PreWeddingandWedding />} />
          <Route path='/modelling-and-acting-photography' element={<ModelingAndActing />} />
          <Route path='/commercial-and-industrial-photography' element={<CommercialAndIndustrial />} />
          <Route path='/fashion-and-beauty-photography' element={<FashionandBeauty />} />
          <Route path='/products-and-brands-photography' element={<ProductsandBrands />} />
          <Route path='/events-and-celebrations-photography' element={<EventsandCelebrations />} />
          <Route path='/creative-and-arts-photography' element={<CreativeandArts />} />
          <Route path='/maternity-and-baby-photography' element={<MaternityAndBaby />} />
          <Route path='/love-and-family-photography' element={<LoveandFamily />} />
          <Route path='/celebrity-and-movie-posters' element={<CelebrityAndMovieMedia />} />

          <Route path='/acting-photography-portfolio' element={<ActingPhotographyPortfolio />} />
          <Route path='/child-photography-portfolio' element={<ChildPhotographyPortfolio />} />
          <Route path='/wedding-photography-portfolio' element={<WeddingPhotographyPortfolio />} />
          <Route path='/product-photography-portfolio' element={<ProductPhotographyPortfolio />} />
          <Route path='/fashion-photography-portfolio' element={<FashionPhotographyPortfolio />} />
          <Route path='/interior-photography-portfolio' element={<InteriorPhotographyPortfolio />} />
          <Route path='/corporate-photography-portfolio' element={<CorporatePhotographyPortfolio />} />

          <Route path='/image-gallery' element={<ImageGallery />} />
          <Route path='/video-gallery' element={<VideoGallery />} />
          <Route path='/career' element={<Career />} />
          <Route path="/contact-us" element={<ContactUs />} />
          

        </Routes>
      <Footer />
      </BrowserRouter>

      
      
    </div>
  )
}

export default App
